import React from 'react';
import PropTypes from 'prop-types';
import {AnchorIntl} from 'components/intl';
import environment from 'lib/environment';
import {
  FormattedMessage,
  defineMessages,
} from 'react-intl';
import classes from './signin-security.scss';

const organizationCenterUrl = environment.get().organization_center_url;
const t = defineMessages({
  'enterprise-signin.enterprise-sign-in': {
    id: 'enterprise-signin.enterprise-sign-in',
    defaultMessage: 'Enterprise Sign In',
    description: 'Title string for the Enterprise Sign In section',
  },
  'enterprise-signin.info-text-has-domain': {
    id: 'enterprise-signin.info-text-has-domain',
    defaultMessage: 'Allow members of your team to sign in with their company username & password (e.g. from Active Directory)',
    description: 'Information string for the Enterprise Sign In section when verified domains have been set up.',
  },
  'enterprise-signin.info-text-no-domain': {
    id: 'enterprise-signin.info-text-no-domain',
    defaultMessage: 'Set up domains so that members of your team can sign in with their company username & password (e.g. from Active Directory)',
    description: 'Information string for the Enterprise Sign In section when no verified domains have been set up',
  },
  'enterprise-signin.add-company-link': {
    id: 'enterprise-signin.add-company-link',
    defaultMessage: 'Add company',
    description: 'Link text for adding a new company to enterprise sign in.',
  },
  'enterprise-signin.edit-company-link': {
    id: 'enterprise-signin.edit-company-link',
    defaultMessage: 'Edit company',
    description: 'Link text for editing company/domains for enterprise sign in.',
  },
});

export const EnterpriseSignIn = ({
  hasVerifiedOrgDomains,
  hideEnterpriseSignInDetails,
  showEditLink,
}) => (
  <div>
    <div className="row">
      <div id="enterprise-signin-section-title" className="col-xs-12 sectionTitle">
        <FormattedMessage {...t['enterprise-signin.enterprise-sign-in']} />
      </div>
    </div>
    {!hideEnterpriseSignInDetails &&
      <div>
        <div id="enterprise-signin-section-info" className={classes['sectionInfo']}>
          <FormattedMessage
            {...t[hasVerifiedOrgDomains ?
              'enterprise-signin.info-text-has-domain' :
              'enterprise-signin.info-text-no-domain']}
          />
        </div>
        <div id="enterprise-signin-section-enroll" className={classes['linkLabel']}>
          <AnchorIntl
            a={{
              href: organizationCenterUrl,
              message: t[showEditLink ?
                'enterprise-signin.edit-company-link' :
                'enterprise-signin.add-company-link'
              ],
            }}
          />
        </div>
      </div>}
  </div>
);

EnterpriseSignIn.propTypes = {
  hasVerifiedOrgDomains: PropTypes.bool.isRequired,
  hideEnterpriseSignInDetails: PropTypes.bool.isRequired,
  showEditLink: PropTypes.bool.isRequired,
};

export default EnterpriseSignIn;
